import React, { isValidElement } from 'react';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { isFalsy } from '../../../../utils/common';
import { UniversityPlaceholder } from '../../icons';
var InventoryCard = function (_a) {
    var courseName = _a.courseName, universityName = _a.universityName, cityName = _a.cityName, country = _a.country, footerCta = _a.footerCta, className = _a.className, openCourseDetails = _a.openCourseDetails, onUniversityNameClick = _a.onUniversityNameClick;
    var getLocation = function () {
        if (!isFalsy(cityName) && !isFalsy(country)) {
            return "".concat(cityName, ", ").concat(country);
        }
        else if (!isFalsy(country)) {
            return "".concat(country);
        }
        else if (!isFalsy(cityName)) {
            return "".concat(cityName);
        }
        else {
            return '';
        }
    };
    return (React.createElement("div", { className: "lfc-bg-white lfc-border lfc-border-gray-1300 lfc-rounded-lg lfc-flex lfc-flex-col lfc-justify-between lfc-shadow ".concat(className) },
        React.createElement(Typography, { variant: "subtitle1", className: "lfc-text-primary-500 lfc-pb-4 lfc-py-6 lfc-px-4 lfc-truncate hover:lfc-text-clip hover:lfc-whitespace-pre-wrap lfc-cursor-pointer hover:lfc-underline", onClick: function () {
                openCourseDetails === null || openCourseDetails === void 0 ? void 0 : openCourseDetails('link');
            } }, courseName),
        React.createElement("div", { className: "lfc-flex lfc-items-center lfc-gap-x-2 lfc-py-6 lfc-px-4" },
            universityName && (React.createElement("div", { role: "button", className: "flex items-end gap-x-1 lfc-cursor-pointer", onClick: onUniversityNameClick },
                React.createElement("div", null,
                    React.createElement(UniversityPlaceholder, null)),
                React.createElement(Typography, { onClick: function () { return onUniversityNameClick === null || onUniversityNameClick === void 0 ? void 0 : onUniversityNameClick(); }, variant: "subtitle2", className: "lfc-text-gray-900 hover:lfc-underline lfc-cursor-pointer" }, universityName))),
            React.createElement("div", { className: "lfc-flex lfc-items-end lfc-gap-x-1" },
                React.createElement("div", null,
                    React.createElement(LocationOnRoundedIcon, { sx: { fontSize: '20px' }, className: "lfc-ml-2 lfc-text-gray-600" })),
                React.createElement(Typography, { variant: "subtitle2", className: "lfc-text-gray-900" }, getLocation()))),
        React.createElement("div", { className: "lfc-flex lfc-py-3 lfc-px-4 lfc-bg-[#FAFAFA] lfc-gap-x-2 lfc-border lfc-border-grey-200 lfc-rounded" },
            React.createElement(Button, { color: "primary", variant: "contained", onClick: function () {
                    openCourseDetails === null || openCourseDetails === void 0 ? void 0 : openCourseDetails('button');
                }, className: "lfc-flex-1" },
                React.createElement(Typography, { variant: "subtitle2", className: "lfc-text-white" }, "View Course Details")),
            isValidElement(footerCta) ? footerCta : null)));
};
export default InventoryCard;
//# sourceMappingURL=CourseCard.js.map